import React, { Component } from 'react'
import Alert from '@mui/material/Alert';

export default class AlertPopup extends Component {
    constructor(props) {
        super(props);
        this.state = {

        }
    }
    render() {
        const { severity, message } = this.props;
        return (
            <div style={{position:'fixed',width:'30%',top:'10%',zIndex:'99',right:'1%'}}>
                <Alert variant="filled" severity={severity}>
                    {message}
                </Alert>
            </div>
        )
    }
}
